// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".billing-history-container {\n    width: 85%;\n    overflow: hidden;\n    margin: 50px 20px 20px 20px;\n    height: -webkit-fill-available;\n}\n\n.billing-history-container h2 {\n    color: #004BA0;\n}\n\ntd {\n    font-size: 14px !important;\n}\n", ""]);
// Exports
module.exports = exports;
